import type { ThemeEnum } from '@/constants';
import { BusinessType, TabType } from '@/constants/subscription';
import { atom } from 'jotai';
import { RedEnvelopePromotion } from '@meitu/subscribe-core';
import { getIncomeSource } from '@/utils/vip';
import { curTabAtom } from './sub';
import { getLocaleStore } from '@/i18n/localeStore';

const { $t } = getLocaleStore();

/**
 * 页面前置逻辑是否初始化完成
 */
export const themeAtom = atom<ThemeEnum>('light' as ThemeEnum);

/**
 * 页面前置逻辑是否初始化完成
 */
export const isInitAtom = atom<boolean>(false);

/**
 * 父页面通过 postMessage 下发的 task_id（先买后用等场景）
 */
export const taskIdAtom = atom<string>('');

/**
 * 父页面通过 postMessage 下发的 trackData（业务透传的自定义埋点数据）
 */
export const extraTrackDataAtom = atom<Record<string, any>>({});

/**
 * 父页面通过 postMessage 下发的 transferData（业务透传的自定义透传订单表数据）
 */
export const extraTransferDataAtom = atom<Record<string, any>>({});

/**
 * 控制桌面端订阅提审状态时是否需要勾选协议
 */
export const auditVersionStatusAtom = atom<boolean>(false);

/**
 * 切换兑换码功能模块
 */
export const visibleExchangeAtom = atom<boolean>(false);

/**
 * 成功结果弹窗的状态
 */
export const visibleResultAtom = atom<boolean>(false);

/**
 * 成功结果弹窗的标题
 */
export const resultModalTitleAtom = atom<string>($t((v) => v.Title_ThankYouSubscription));

/**
 * 开票弹窗的状态
 */
export const visibleInvoicingAtom = atom<boolean>(false);

/**
 * 联系商务弹窗的状态
 */
export const visibleBusinessAtom = atom<boolean>(false);

/**
 * 联系商务弹窗的类型
 */
export const businessTypeAtom = atom<BusinessType>();

/**
 * 美豆剩余弹窗的状态
 */
export const visibleMeidouInfoModalAtom = atom<boolean>(false);

/**
 * 绑定手机号弹窗的状态
 */
export const visibleBindPhoneAtom = atom<boolean>(false);

/**
 * 自动需求服务弹窗的状态
 */
export const visibleServiceNoticeAtom = atom<boolean>(false);

/**
 * 是否命中新版UI实验组
 */
export const isViewNewUiAtom = atom<boolean>(false);

/**
 * 是否激活产品卡片动效
 */
export const activeProductMotionAtom = atom<boolean>(false);

/**
 * 红包弹窗信息
 */
export const redEnvelopePromotionInfoAtom = atom<RedEnvelopePromotion>();

/**
 * 对公转账弹窗的状态
 */
export const visibleCmbChinaAtom = atom<boolean>(false);
/**
 * 是否存在待支付对公转账订单
 */
export const hasCmbChinaToPaidAtom = atom<boolean>(false);

/**
 * 是否展示小卡片
 */
export const showTabsAtom = atom<boolean>(false);

/**
 * 是否展示公告栏
 */
export const showNoticeBarAtom = atom<boolean>((get) => {
  // const curTab = get(curTabAtom);
  // return (
  //   getIncomeSource() === 'MTXX-WEB' &&
  //   !isTeamSubscription &&
  //   ([TabType.PRO_SUB, TabType.SUB].includes(curTab) || subscribeType === SubscribeType.MEIDOU)
  // );

  return false;
});
